/* 
Bridge de comunicación con la Api, diferentes funciones para coger información del usuario.
*/

import axios from "axios";
import { HEADER, TOKENIDENTITY, GETDATA} from "../constants";
import { API_URI, URLIDENTITY, LOCAL } from "../config";
import Cookies from "js-cookie";

export default class User {
  static INSTANCE = new User();

  user = { //Ejemplo de objeto usuario
    id: 0,
    isPrivacity: true,
    isPublicity: true,
    email: "test@test.com",
    mobile: "661661661",
    cp: "08002",
    idPopulation: "8051",
    idProvince: "33",
    idCenter: "86",
    gender: "1",
    born: "1993-12-15",
    dni: "07839337V",
    lastname: "De los Palotes",
    name: "Pepito"
  };

  User() { }

  login = async (email, password) => {
    const body = {
      username: email,
      password: password
    };

    if (!LOCAL) {
      let url = `${URLIDENTITY}/api/login${URLIDENTITY === "http://localhost:5000" ? "/local" : "" }`;
      return await axios.post(url, body, HEADER(false)).then(response => {
        //Cookies.set('refresh_token', response.data.refresh_token, HttpOnly)
        response.data.born = response.data.born.split("T")[0];
        Cookies.set("iluToken", response.data.token, { expires: 1 });
        delete response.data.token;
        Cookies.set("iluUser", response.data, { expires: 1 });
        this.user = response.data;
        return this.user;
      });
    } else {
      return this.user;
    }
  };

  getPoints = (userId) => {
    return new Promise((resolve, reject) => {
      let url = `/Clientes/${userId}/Points`;
      GETDATA(url,
        response => {
          resolve(response.data);
        });
    });
  }

  restorePassword = async mail => {
    if (!LOCAL) {
      let url = `${API_URI}/Clientes/newPassword`;
      return TOKENIDENTITY().then(headerWithToken => {
        console.log(headerWithToken);
        
        return axios
          .post(url, { mail }, headerWithToken).then(response => {
            return response.data;
          });
      });

    } else {
      return true;
    }
  };

  resendConfirmationMail = async mail => {
    if (!LOCAL) {
      let url = `${API_URI}/Clientes/resendConfirmationMail?email=${mail}`;
      return TOKENIDENTITY().then(headerWithToken => {
        return axios
          .get(url, headerWithToken).then(response => {
            return response.data;
          });
      });

    } else {
      return true;
    }
  };

  changeUser = async (
    userId,
    user,
    changePassword = false
  ) => {
    let userToChange = {};

    console.log("User.js changeUser function mod RRLL");

    if (changePassword) {
      userToChange = {
        oldPassword: user.oldPassword,
        password: user.password,
        idencr: "263101"
      };
    } else if (user) {
      userToChange = {
        bAceptaPublicidad: user.isPublicity,
        bAceptaCondiciones: user.isPrivacity,
        bConfirmado: user.isConfirm,
      };
      for (let atr in userToChange) {
        let variable = userToChange[atr];
        if (!variable) {
          delete userToChange[atr];
        }
      }
    } else {
      userToChange = {
        bConfirmado: true
      };
    }

    if (!LOCAL) {
      let url = `${API_URI}/Clientes/part/${userId}`;
      return TOKENIDENTITY().then(headerWithToken => {
        return axios
          .put(url, userToChange, headerWithToken).then(response => {
            return response.data;
          });
      });
    } else {
      return this.user;
    }
  };
}
